import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { TransferModel } from "../../../../../../../../../Wrap/Models/Models/Transfer/TransferModel";
import { checkPermission } from "../../../../../../../../Shared/Permission/PermissionHelper";
import { Table } from "../../../../../../../../Shared/Table/Table";
import { TransferStatusMapper } from "../../Constant/Content";

interface ITransfers {
    completedTransferIn: TransferModel[];
    headaccount: ClientAccount;
}

const renderCompleteTransfers = (data: TransferModel[], claccountId: string) => {
    // calculate Total amount
    const reducer = (accumulator, currentvalue) => {
        return accumulator + currentvalue.Amount;
    };
    const totalAmount = data.reduce(reducer, 0);
    return (
        <>
            <Table
                cssWrapper="table-subtle table-first-last-cell-padding-reset mb-10"
                data={data}
                col={[
                    {
                        title: "Completed date",
                        key: "DateCompleted",
                        render: (data) => {
                            return JsonDateParser.getFormatDate(data, "yyyy-MM-dd");
                        },
                    },
                    { title: "Ceding providers", key: "Provider" },
                    {
                        title: "Status",
                        key: "Status",
                        render: (data) => {
                            return <span style={{ color: "green" }}>{TransferStatusMapper[data]}</span>;
                        },
                    },
                    {
                        title: "Amount",
                        key: "Amount",
                        tdCssWrapper: "cell-right",
                        thCssWrapper: "cell-right",
                        render: (data) => {
                            return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2);
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Total", colSpan: 3 },
                    {
                        data: MoneyDisplayHelper.FromatMoneyDisplay(totalAmount, CurrencyCode.GBP, true, 2),
                        colSpan: 1,
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            />
            {checkPermission(UserClaim.AdviserPortalDluReregistrationTransfersCanView) && (
                <a
                    href={`/clients/tracking/reregistration-transfers.aspx?claccountid=${claccountId}&txtStatus=Completed`}
                    className="hyperlink"
                >
                    View completed transfers
                </a>
            )}
        </>
    );
};

export const Transfers = (props: ITransfers) => {
    return (
        <>
            <h2>Transfers</h2>
            {props.completedTransferIn?.length > 0 ? (
                <div className="panel-subtle mb-26 pt-2 pb-32">
                    {renderCompleteTransfers(props.completedTransferIn, props.headaccount?.HeadClAccountId)}
                </div>
            ) : (
                <div className="panel-subtle mb-35">No transfer(s) currently set up for this client</div>
            )}
        </>
    );
};
